import { FormControl, ValidatorFn } from '@angular/forms';

export function setFormControlValidators(
  formControl: FormControl,
  validatorFn: (() => ValidatorFn) | null,
) {
  if (formControl) {
    if (validatorFn && typeof validatorFn === 'function') {
      formControl.setValidators([validatorFn()!]);
    } else {
      formControl.clearValidators();
    }

    formControl.updateValueAndValidity();
  }
}
